import script from "./CompanionPause.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionPause.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionPause.vue?vue&type=style&index=0&id=5a47c2bf&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a47c2bf"]])

export default __exports__